import { render, staticRenderFns } from "./CommissionProductModal.vue?vue&type=template&id=58c23c3e&scoped=true"
import script from "./CommissionProductModal.vue?vue&type=script&lang=js"
export * from "./CommissionProductModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58c23c3e",
  null
  
)

export default component.exports